import client from './client';
import { Document, PaginatedResponse } from '../types';

export const documentsApi = {
  list: (params?: {
    page?: number;
    per_page?: number;
    type?: string;
    status?: string;
  }) => client.get<PaginatedResponse<Document>>('/documents', { params }),

  get: (id: string) => client.get<Document>(`/documents/${id}`),

  generate: (data: { type: string; parameters: Record<string, string>; employee_id?: string }) =>
    client.post<Document>('/documents/generate', data),

  upload: (formData: FormData) =>
    client.post<Document>('/documents/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  download: (id: string) =>
    client.get(`/documents/${id}/download`, { responseType: 'blob' }),

  delete: (id: string) => client.delete(`/documents/${id}`),
};
